"use strict";exports.__esModule = true;exports.symbol = symbol;function symbol() {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 16 16" id=icon-chevron-right-small><path d="m12.707 8.707-6 6a1 1 0 0 1-1.414-1.414L10.586 8 5.293 2.707a1 1 0 0 1 1.414-1.414l6 6a1 1 0 0 1 0 1.414Z"></path></symbol>';
}